import { Outlet } from 'react-router-dom';

import { Content } from '@american-autonomy/rantizo-ui';

import Toast from 'components/Toast';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SimpleLayout: FunctionComponent<Props> = ({ testId = TEST_ID }) => (
    <>
        <div className={styles.simpleLayout} data-testid={testId}>
            <Content className={styles.content}>
                <Outlet />
            </Content>
        </div>

        <Toast />
    </>
);

export default SimpleLayout;
